import DropdownTreeSelect, { NodeAction, TextProps, TreeNode, TreeNodeProps } from 'react-dropdown-tree-select';
import styled from 'styled-components';
import 'react-dropdown-tree-select/dist/styles.css';
import { useEffect, useState } from 'react';

interface TreeSelectProps {
  data: TreeNodeProps[];
  marginBottom?: string;
  onChange?(value: string): void;
  dropdownMaxHeight?: string;
  value?: string;
}

interface ContentProps {
  marginBottom?: string;
  dropdownMaxHeight?: string;
}

export function TreeSelect({ data, marginBottom, onChange, dropdownMaxHeight = '', value = '' }: TreeSelectProps) {
  const customTexts: TextProps = {
    inlineSearchPlaceholder: 'Pesquisar...',
    //label: "",
    labelRemove: 'Remova',
    noMatches: 'Não Encontrado',
    placeholder: 'Selecionar...',
  };

  const mapData = (data: TreeNodeProps[], value: string): TreeNodeProps[] => {
    const newdata: TreeNodeProps[] = JSON.parse(JSON.stringify(data));
    newdata.map((v) => {
      if (!v) return; // eslint-disable-line array-callback-return

      v.checked = false;
      v.expanded = false;
      if (v.value === value) {
        v.checked = true;
        v.expanded = true;
      }

      if (v.children && v.children.length) {
        v.children = mapData(v.children, value);
      }

      return v;
    });
    return newdata;
  };

  const [mappedData, setMappedData] = useState<TreeNodeProps[]>(mapData(data, value));

  const onChangeHandler = (currentNode: TreeNode, selectedNodes: TreeNode[]) => {
    //console.log('onChange::', currentNode, selectedNodes);
    onChange && onChange(currentNode.checked ? currentNode.value : '');
  };
  const onAction = (node: TreeNode, action: NodeAction) => {
    //console.log('onAction::', action, node)
  };
  const onNodeToggle = (currentNode: TreeNode) => {
    //console.log('onNodeToggle::', currentNode)
  };

  useEffect(() => {
    if (value) {
      setMappedData(mapData(data, value));
    } else {
      setMappedData(data);
    }
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Content marginBottom={marginBottom} dropdownMaxHeight={dropdownMaxHeight}>
      <DropdownTreeSelect
        mode="radioSelect"
        data={mappedData}
        onChange={onChangeHandler}
        onAction={onAction}
        onNodeToggle={onNodeToggle}
        texts={customTexts}
      />
    </Content>
  );
}

const Content = styled.div<ContentProps>`
  .dropdown {
    width: 100%;
    height: 65px;
    display: block;
    margin-bottom: ${({ marginBottom }) => marginBottom || 0 };

    &::after {
      content: "";
      display: block;
      width: 40px;
      position: absolute;
      top: 2px;
      right: 2px;
      bottom: 2px;
      border-radius: 5px;
      background: ${({ theme }) => theme.colors.gray.light};
      background: linear-gradient(90deg, rgba(247,247,247,0) 0%, rgba(247,247,247,1) 100%);
      z-index: 2;
      pointer-events: none;

      @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
        width: 100px;
      }
    }

    .infinite-scroll-component {
      //overflow: scroll;
      max-height: ${({ dropdownMaxHeight }) => dropdownMaxHeight || 'none' };;
    } 

    @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
      height: 54px;
    }
  }

  .dropdown-trigger {
    width: 100%;
    padding: 0 !important;
    margin: 0 !important;
    border: none !important;

    &::after {
      content: none !important;
      pointer-events: none;
    }

    ul {
      padding: 0 12px;
      white-space: nowrap;
      width: calc(100% - 2px);
      overflow: hidden;
      display: block;
    }

    li:not(:last-child) {
      position: relative;
      z-index: 1;
      margin: 20px 4px;

      > span {
        padding: 2px 6px;
        border-radius: 6px;
        font-size: 18px;

        > button {
          margin-left: 8px;
          font-size: 18px;
        }
      }

      @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
        margin: 14px 4px;

        > span {
          font-size: 16px;
  
          > button {
            font-size: 16px;
          }
        }
      }
    }

    li:last-child {
      width: 100%;
    }

    input {
      margin: 0;
      width: 100%;
      height: 65px;
      border-radius: 5px;
      background-color: ${({ theme }) => theme.colors.gray.light };
      border: ${({ theme }) => `2px solid ${theme.colors.gray.dark}`};
      font-size: 17px;
      padding: 0 16px;
      color: ${({ theme }) => theme.colors.gray.darker };
      //width: 100%;
      position: absolute;
      top: 0;
      left: 0;

      &::-webkit-calendar-picker-indicator {
        display: none;
        -webkit-appearance: none;
      }

      @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
        height: 54px;
        font-size: 15px;
        max-width: 100%;
      }
    }
  }

  .dropdown-content {
    padding: 0 !important;
    top: 72px;
    background-color: ${({ theme }) => theme.colors.gray.light} !important;
    width: 100%;
    padding: 6px;
    border-radius: 5px;

    @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
      top: 60px;
    }

    i {
      font-style: normal;
      font-size: 18px;
      width: 18px;
      display: inline-block;
      text-align: center;
      height: 22px;
      vertical-align: middle;

      @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
        font-size: 16px;
      }
    }

    input {
      display: none;
    }

    input:checked ~ .node-label {
      background-color: ${({ theme }) => theme.colors.gray.medium} !important;
    }

    label {
      height: 22px;
      font-size: 18px;
      display: inline-block;
      vertical-align: middle;
      @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
        font-size: 16px;
      }
    }

    li {
      background-color: transparent;
      font-size: 16px;
      
    }
  }
`;